import { createAction } from 'redux-actions';

export const answerDialogToggle = createAction('verifyCause/ANSWER_DIALOG_TOGGLE');
export const answerClick = createAction('verifyCause/ANSWER_CLICK');
export const setVerifyCauseValues = createAction('verifyCause/SET_VALUES');
export const resetAllManualObservations = createAction('verifyCause/RESET_MANUALS');
